import Lenis from 'lenis';
import Snap from 'lenis/snap';
import gsap from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';

if (viewport().width > 767) {

    const lenis = new Lenis({
        anchors: false
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    gsap.ticker.lagSmoothing(0);

    const snap = new Snap(lenis, {
        distanceThreshold: '15%',
    });

    if ($('.key-visual').length > 0) {
        snap.addElement(document.querySelector('.key-visual'), {
            align: ['end'],
        });
    }

    $('body').on('stop-lenis', function () {
        lenis.stop();
    }).on('start-lenis', function () {
        lenis.start();
    });
}
